// Shared by both navigation versions: keep localized category search labels
// readable while submitting their original Shopify search expression.
(() => {
  document.addEventListener('submit', event => {
    const category = document.querySelector('[data-lnw-menu-search-label]');
    const form = event.target;
    if (!category || !(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[name="q"]');
    if (!input || input.value.trim() !== category.dataset.lnwMenuSearchLabel) return;
    const url = new URL(form.action, location.href);
    if (url.origin !== location.origin || !url.pathname.endsWith('/search')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    url.search = '';
    new FormData(form).forEach((value, key) => { if (typeof value === 'string' && key !== 'q') url.searchParams.append(key, value); });
    url.searchParams.set('q', category.dataset.lnwMenuSearchQuery);
    location.assign(url.href);
  }, true);
})();
